/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CommonService } from '../services/common.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class MoveOrderConfimationModalContext {
  public order?: any;
  public futurePeriodLbl?: any;
  public fromReprocess?: boolean;
}

@Component({
  selector: 'move-order-confirmation-modal',
  templateUrl: './move-order-confirmation-modal.component.html',
  styleUrls: ['./move-order.component.scss'],
  // providers: [CommonService],
  encapsulation: ViewEncapsulation.None
})
export class MoveOrderConfimationModalComponent implements OnInit {
  @Input() context!: MoveOrderConfimationModalContext;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  public genTypes: any = {};

  constructor(public bsModalRef: BsModalRef<MoveOrderConfimationModalContext>, private commonService: CommonService) {}

  ngOnInit(): void {}

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow() {
    this.closeModal.emit('closed');
    this.bsModalRef.hide();
  }

  public confirmMoveOrder() {
    this.closeModal.emit('confirmed');
    this.bsModalRef.hide();
  }
}
